import { StyledHome, StyledLogo, Name, Subtitle } from './StyledHome';

const Home = () => {

  return (
    (
    <StyledHome>
      <StyledLogo alt="YTH Logo"/>
      <Name>Yik Tung Ho</Name>
      <Subtitle>New Media Researcher</Subtitle>
    </StyledHome>
    )
  )
};

export default Home;
